import classNames from 'classnames';
import styles from './Footer.module.scss';
import { AppVersion, View, DateTime } from 'components';

/**
 * Footer
 *
 * @return {JSX.Element}
 */
const Footer = ({ className }) => {
  return (
    <View
      className={classNames(styles.Footer, className, `${Footer.displayName}`)}
    >
      <DateTime />
      <AppVersion />
      <a
        href="https://propa.co.uk/legal/app/privacy-policy"
        target="_blank"
        rel="noreferrer"
      >
        Privacy policy
      </a>

      <a
        href="https://propa.co.uk/legal/app/terms-and-conditions"
        target="_blank"
        rel="noreferrer"
      >
        Terms
      </a>
      <a
        href="https://propa.co.uk/main/help.html"
        target="_blank"
        rel="noreferrer"
      >
        Support
      </a>
    </View>
  );
};

Footer.displayName = 'Footer';

export default Footer;
